import React from "react"

type Props = {
  className?: string
  color?: string
}

const Hide = (props: Props) => {
  const { className, color = "var(--slate)" } = props
  return (
    <svg
      className={className}
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9969 0.626109C15.375 0.859725 15.4921 1.35561 15.2585 1.7337L14.7275 2.59307C14.3306 3.23547 13.8645 3.79537 13.3471 4.27277L14.51 5.92434C14.7658 6.28775 14.6787 6.78976 14.3152 7.04562C13.9519 7.3015 13.4498 7.21431 13.194 6.85092L12.0568 5.23582C11.5751 5.52264 11.068 5.75374 10.5454 5.92915L10.919 7.50361C11.0216 7.93604 10.7542 8.36979 10.3218 8.47239C9.88935 8.575 9.45563 8.30763 9.353 7.87521L8.97544 6.28399C8.30874 6.36529 7.63321 6.36271 6.96703 6.27623L6.58763 7.87521C6.48502 8.30763 6.05127 8.575 5.61885 8.47239C5.1864 8.36979 4.91903 7.93604 5.02164 7.50361L5.4 5.9091C4.88211 5.73069 4.37984 5.49727 3.90282 5.20882L2.74666 6.85092C2.49079 7.21431 1.98877 7.3015 1.62537 7.04562C1.26197 6.78976 1.17479 6.28775 1.43066 5.92434L2.6189 4.2367C2.12436 3.7741 1.6775 3.23526 1.29401 2.62016L0.743052 1.73646C0.507915 1.35931 0.623036 0.862958 1.00018 0.627821C1.37733 0.392684 1.87368 0.507805 2.10882 0.884951L2.65978 1.76865C5.13037 5.73133 10.9037 5.71971 13.3583 1.74708L13.8893 0.887708C14.1229 0.509617 14.6188 0.392495 14.9969 0.626109Z"
        fill={color}
      />
    </svg>
  )
}

export default Hide
